import i18n from "../../../../Utils/i18next/i18next";
import store from "../../../../store";
import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { cloneDeep, set } from "lodash";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { leasingReducer } = store.getState();
  const { updateTableRegistry, loadData, update, updateSingleRegistry, uuid } =
    props;
  const data = cloneDeep(values);

  // if (values?.contact?.value) set(data, "contact.uuid", values?.contact?.value);

  if (values?.representative?.value)
    set(data, "representative.uuid", values?.representative?.value);

  if (values?.leasingType?.value)
    set(data, "leasingType.uuid", values?.leasingType?.value);

  let payload;

  if (!update) {
    data.status = leasingReducer?.availableStatuses.find(
      (el) => !!el.isSelected
    );

    const res = await GlobalAuthFetch({
      path: `/leasing`,
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/leasing/${uuid}`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);
    props.setErrorHeader(1, true);
    return;
  }

  props.setErrorHeader(0, false);
  props.setErrorHeader(1, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();
  props.handleHide();
};

export const onValidate = (values, props) => {
  // const { update } = props;
  const errorsStep0 = {};
  const errorsStep1 = {};

  if (!values.leasingNumber) {
    errorsStep0.leasingNumber = t("global:leasing.errors.leasingNumber");
  }

  if (!values.title) {
    errorsStep0.title = t("global:leasing.errors.title");
  }

  if (!values.contact) {
    errorsStep0.contact = t("global:leasing.errors.contact");
  }

  if (!values.leasingType) {
    errorsStep0.leasingType = t("global:leasing.errors.leasingType");
  }

  if (!values.startDate) {
    errorsStep1.startDate = t("global:leasing.errors.startDate");
  }

  if (!values.endDate) {
    errorsStep1.endDate = t("global:leasing.errors.endDate");
  }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }
  if (
    !props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length > 0
  ) {
    props.setErrorHeader(1, true);
  }
  if (
    !!props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length <= 0
  ) {
    props.setErrorHeader(1, false);
  }
  return { ...errorsStep0, ...errorsStep1 };
};
